import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Input } from 'semantic-ui-react';
import onClickOutside from 'react-onclickoutside';

import CommonErrorIcon
  from 'components/common/CommonErrorIcon';
import CommonMessage from 'components/common/CommonMessage';

import './CommonStanaloneInput.css';


const ENTER_KEY = 13;

class CommonStanaloneInput extends Component {
  static propTypes = {
    executedAction: PropTypes.func.isRequired,
    fieldName: PropTypes.string.isRequired,
    initValue: PropTypes.string,
    patchError: PropTypes.object,
    placeholder: PropTypes.string,
  };

  static defaultProps = {
    initValue: null,
    patchUserError: null,
    placeholder: null,
  };

  state = {
    initialValue: '',
    currentValue: '',
    invalid: false,
  };

  componentDidMount() {
    document.addEventListener('keyup', this.onEnterClick);
    if (this.props.initValue) {
      this.setState({
        initialValue: this.props.initValue,
        currentValue: this.props.initValue,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentValue !== this.state.currentValue) {
      this.setState({ invalid: false });
    }

    if (prevProps.initValue !== this.props.initValue) {
      this.setState({ currentValue: this.props.initValue });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onEnterClick);
  }

  executeValidation = () => {
    if (this.props.validate) {
      this.setState({
        invalid: this.props.validate(
          this.props.fieldName,
          this.state.currentValue,
        ),
      });
    }
  };

  onEnterClick = (event) => {
    if (event.keyCode === ENTER_KEY) {
      this.executeValidation();
      this.changeValue();
    }
  };

  handleClickOutside = () => {
    this.executeValidation();
    this.changeValue();
  };

  changeValue = () => {
    const { fieldName, executedAction } = this.props;
    const { initialValue, currentValue, invalid } = this.state;

    if (currentValue !== initialValue) {
      this.setState({ initialValue: currentValue.trim() });
      const form = new FormData();
      form.append(fieldName, currentValue.trim());
      if (!invalid) { executedAction(form); }
    }
  };

  render() {
    const {
      label,
      fieldName,
      patchError,
      placeholder,
    } = this.props;

    const { invalid, currentValue } = this.state;

    return (
      <div className={`common-standalone-input__component${invalid ? ' error' : ''}`}>
        <div className="input-wrapper">
          <Input
            value={currentValue}
            placeholder={placeholder}
            onChange={(e) => {
              e.preventDefault();
              this.setState({ currentValue: e.target.value });
            }}
            onBlur={() => { this.handleClickOutside(); }}
          />
          {invalid &&
            <CommonErrorIcon
              key={`${invalid[fieldName]}-error`}
              errorId={`${invalid[fieldName]}-error-id`}
              errorText={invalid[fieldName]}
            />
          }
        </div>

        <div className="divider" />

        {label &&
          <div className="label">
            {label}
          </div>
        }

        {patchError &&
          patchError[fieldName] &&
          patchError[fieldName].length > 0 &&
          <CommonMessage
            error
            content={patchError[fieldName][0]}
          />
        }

      </div>
    );
  }
}

export default onClickOutside(CommonStanaloneInput);
